import * as React from 'react';
import { Row, Col } from 'antd';
import i18n from 'i18n-react';
import CancelDetail from '../cancelDetail/CancelDetail';
import { Operation } from '../../../../const/FlightModel';

function CancelResumeDetail(props) {
  return (
    <div>
      <CancelDetail {...props.cancelInfo} passengerInfo={props.passengerCancelInfo} />
      <Row className="padding-left-xl padding-eight-top-16 text-dark-blue text-500">
        <Col span={8} data-unit="clientBalance" data-test="clientBalanceLabel">
          {getLabel(props.cancelInfo.operation)}
        </Col>
        <Col
          span={16}
          data-unit="balance"
          data-test="balance"
          className="text-right padding-right-xl">
          {currencyPrefix(props.cancelInfo.operation, 'label.currency')}
          {formatValue(props.cancelInfo.balance)}
        </Col>
        <Col span={16} className="text-dark-grey text-sm margin-top-sm text-400">
          <span data-unit="cancelMessage" data-test="cancelMessage">
            {i18n.translate('label.cancelMessage')}
          </span>
        </Col>
      </Row>
    </div>
  );
}

function getLabel(operation) {
  return i18n.translate(
    operation === Operation.PAYMENT
      ? 'features.cancelResumeDetail.totalPaid'
      : 'features.cancelResumeDetail.totalRefund'
  );
}

function formatValue(value) {
  return Math.abs(value)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}

function currencyPrefix(operation, label) {
  const labelWithPrefix = i18n.translate(label);
  return operation === Operation.PAYMENT ? `- ${labelWithPrefix}` : labelWithPrefix;
}

export default CancelResumeDetail;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/cancelResumeDetail/CancelResumeDetail.jsx